// Scripts for the blog post featured categories navigation
document.addEventListener("DOMContentLoaded", () => {
    let blogNavigation = document.querySelector('.blog-navigation');

    // Check if blogNavigation is on the page before doing anything - this is to make sure scripts run properly
    if (blogNavigation) {
        let blogNavigationButton = document.querySelector('.blog-navigation__mobile-show-button');
        let blogNavigationOverlay = document.querySelector('.blog-navigation__overlay');
        let blogNavigationWrapper = document.querySelector('.blog-navigation__wrapper');
        let blogNavigationWrapperHeight = blogNavigationWrapper.offsetHeight;

        blogNavigationWrapper.style.bottom = `-${blogNavigationWrapperHeight}px`;

        window.addEventListener('resize', e => {
            blogNavigationWrapperHeight = blogNavigationWrapper.offsetHeight;
            blogNavigationWrapper.style.bottom = `-${blogNavigationWrapperHeight}px`;
        });

        // Show overlay and navigation buttons when search filter is clicked
        blogNavigationButton.addEventListener('click', (e) => {
            e.preventDefault();

            blogNavigationOverlay.classList.add('blog-navigation__overlay--show');
            blogNavigationWrapper.style.bottom = `0px`;
        });

        // Hide overlay and navigation when overlay is clicked
        blogNavigationOverlay.addEventListener('click', (e) => {
            e.preventDefault();

            blogNavigationOverlay.classList.remove('blog-navigation__overlay--show');
            blogNavigationWrapper.style.bottom = `-${blogNavigationWrapperHeight}px`;
        });
    }
});